import { render, staticRenderFns } from "./ViewPathWidget.vue?vue&type=template&id=37f718ac&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ViewPathWidget.vue?vue&type=script&lang=js&"
export * from "./ViewPathWidget.vue?vue&type=script&lang=js&"
import style0 from "./ViewPathWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports